<template>
  <qx-card title="交易记录">
    <section class="totalData" slot="titleLeft">
      <span>未到期金额：</span>
      <span class="primary num">
        {{totalData.amountAll || 0}}元
      </span>
      <span>已到期金额：</span>
      <span class="primary num">
        {{totalData.amountUse || 0}}元
      </span>
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='serviceProductBO.ajax?cmd=totalOilTransaction'
          :params="fullSearchData"
          bizName="交易数据导出"
          bizCode="exp100048"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  siteTransRecordList,
  siteTransRecordTotal,
} from 'api/service';
import ExportBtn from 'components/exportBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      totalData: {
        amountAll: 0, // 未到期金额
        amountUse: 0, // 已到期金额
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '单号',
          },
          {
            prop: 'createDate',
            label: '交易时间',
          },
          {
            prop: 'amountStr',
            label: '消费金额(元)',
          },
          {
            prop: 'oilPriceStr',
            label: '单价(元/升)',
          },
          {
            prop: 'oilRise',
            label: '加油升数(升)',
          },
          {
            prop: 'otherName',
            label: '消费人',
          },
          {
            prop: 'otherUserBill',
            label: '消费人手机',
          },
          {
            prop: 'plateNumber',
            label: '车牌号',
          },
          {
            prop: 'address',
            label: '消费地址',
          },
          {
            prop: 'getDate',
            label: '结算时间',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: siteTransRecordList,
    async getOtherMsg (params) {
      const res = await siteTransRecordTotal(params);
      if (!res.failed) {
        this.totalData = res;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
.totalData{
  margin-left: 16px;
  .num{
    margin: 0 8px;
  }
}
</style>
